// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__7fp-n","summary":"CartItem_summary__4IOc2","price":"CartItem_price__zY4iS","amount":"CartItem_amount__LJGry","actions":"CartItem_actions__K7vuj"};